import { LottieView } from './LottieView';
export * from './types';
export default LottieView;
